// extracted by mini-css-extract-plugin
export default {"callcontainartopsec":"vmTransfer_callcontainartopsec__rp286","closeTransfer":"vmTransfer_closeTransfer__DnqqC","transTitle":"vmTransfer_transTitle__9DTqy"};